const events = {
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    SCORECARD_DATA_LOADED: 'scorecard.data.loaded',
    SCORECARD_DATA_UPDATED: 'scorecard.data.updated',
    SIGNALR: {
        CONNECTED: 'signalr.connected',
        DISCONNECTED: 'signalr.disconnected',
        SCORECARD_UPDATED: 'scorecard.scorecard.updated',
        SCORECARD_FEEDBACK_CREATED: 'scorecard.feedback.created',
        SCORECARD_FEEDBACK_DELETED: 'scorecard.feedback.deleted',
        SCORECARD_GOAL_UPDATED: 'scorecard.goal.updated',
        SCORECARD_GOAL_DELETED: 'scorecard.goal.deleted',
    },
};

export default events;
